import React from 'react';

function Footer() {
  return (
    <footer className="pb-30 pt-30">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="text-center">
              <p className="fz-13">
                © 2025 Haris Bin Shakeel | Co-Founder{' '}
                <span className="underline main-color">
                  <a href="https://leadsnite.com/" target="_blank">
                    LeadsNite
                  </a>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
